<template>
  <ankh-list :showSearchForm="false" :showBtnGroup="false">
    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :request-params="{type: 'ad'}"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" width="50" :label="$t('序号')" fixed />
        <el-table-column prop="phone" :label="$t('图片')" fixed>
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.photo" ></preview-img>
          </template>
        </el-table-column>
        <el-table-column :label="$t('广告位停留时间')">
          <template v-slot="{row}">
            {{(row.slideSet || 0) + "s"}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('广告链接网址')" prop="link"/>
        <el-table-column :label="$t('创建时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="BANNER_STATUS" :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" width="130">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleChangeStatus(row)">{{ row.status === "open" ?$t('禁用') :$t('启用') }}</el-link>
              <el-link type="primary" :underline="false" @click="handleEdit(row)">{{ $t('编辑') }}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <adv-add-or-edit
          ref="addOrEdit"
          :is-edit="true"
          @save="handleEditSubmit"
          :data="currentRow" />
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AdvAddOrEdit from "@/components/adv/AddOrEdit";
import DictText from "@/components/dict/DictText";
import AnkhList from "@/components/list/AnkhList.vue";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "AdvList",
  components: {PreviewImg, AnkhList, DictText, AdvAddOrEdit, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      currentRow: {}
    }
  },
  methods: {
    //编辑提交
    async handleEditSubmit(data) {
      try {
        const params = Object.assign(this.currentRow, data);
        await request(this.$api.banner.update, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
        this.$refs.addOrEdit.showDialog = false;
      } catch (e) {
        console.log(e);
      }
    },

    // 编辑
    handleEdit(row) {
      this.$refs.addOrEdit.showDialog = true;
      const formatRow = {...row};
      delete formatRow.createTime;
      delete formatRow.updateTime;
      this.currentRow = formatRow;
    },

    // 启用/禁用
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "close" : "open",
        }
        await request(this.$api.banner.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.banner.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.banner.batchDelete,
            codes,
            {isJson: true},
            {message:this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.banner.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
